import { types } from 'constants/DynamicBanner';

const initialState = {
    dynamicBanner: {
        list: {
            loading: false,
            error: '',
            data: [],
            page: 1,
            totalPage: null,
            totalData: 0,
        },
        onUpdate: {
            loading: false,
            error: '',
        },
        onDelete: {
            loading: false,
            error: '',
        },
        detail: {
            loading: false,
            data: {},
            error: '',
        },
    },
};

const dynamicBanner = (state = initialState.dynamicBanner, action) => {
    switch (action.type) {
        case types.GET_DYNAMIC_BANNER_LOADING:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: true,
                },
            };
        case types.GET_DYNAMIC_BANNER_SUCCESS:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    data: action.data,
                    totalPage: parseInt(action.totalPage),
                    totalData: parseInt(action.totalData),
                    page: action.page || state?.list?.page,
                },
            };
        case types.GET_DYNAMIC_BANNER_FAILED:
            return {
                ...state,
                list: {
                    ...state.list,
                    loading: false,
                    error: action.message,
                },
            };
        case types.CREATE_DYNAMIC_BANNER_LOADING:
            return {
                ...state,
                onCreate: {
                    ...state.onCreate,
                    loading: true,
                },
            };
        case types.CREATE_DYNAMIC_BANNER_SUCCESS:
            return {
                ...state,
                onCreate: {
                    ...state.onCreate,
                    loading: false,
                },
            };
        case types.CREATE_DYNAMIC_BANNER_FAILED:
            return {
                ...state,
                onCreate: {
                    ...state.onCreate,
                    loading: false,
                    error: action.message,
                },
            };
        case types.GET_DETAIL_DYNAMIC_BANNER_LOADING:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    loading: true,
                },
            };
        case types.GET_DETAIL_DYNAMIC_BANNER_SUCCESS:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    data: action.data,
                    loading: false,
                },
            };
        case types.GET_DETAIL_DYNAMIC_BANNER_FAILED:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    loading: false,
                    error: action.message,
                },
            };
        case types.UPDATE_DYNAMIC_BANNER_LOADING:
            return {
                ...state,
                onUpdate: {
                    ...state.onUpdate,
                    loading: true,
                },
            };
        case types.UPDATE_DYNAMIC_BANNER_SUCCESS:
            return {
                ...state,
                onUpdate: {
                    ...state.onUpdate,
                    loading: false,
                },
            };
        case types.UPDATE_DYNAMIC_BANNER_FAILED:
            return {
                ...state,
                onUpdate: {
                    ...state.onUpdate,
                    loading: false,
                    error: action.message,
                },
            };
        default:
            return state;
    }
};

export default dynamicBanner;
